import React, { Component } from "react";
import { validateAccessToken } from "../../apiFactory/QueryBuilder";
import apiUrlConfig from "../../environmentSettings";
import { setUserProperties } from "../../services/DashboardDesigner/amplitudeService";

class Login extends Component {
	constructor(props) {
		super(props);
	}

	authenticateUser = (accessToken, cb) => {
		return validateAccessToken(accessToken).then(res => {
			return res;
		});
	};

	loginUser = (authServiceUrl, exchangeTokenUrl) => {
		authLogin(authServiceUrl, exchangeTokenUrl).then(accessToken => {
			if (accessToken && accessToken.accessTokenId) {
				window.localStorage.setItem("$LoopBack$accessTokenId", accessToken.accessTokenId);
				window.localStorage.setItem("$LoopBack$currentUserId", accessToken.userId);
				setUserProperties();
				this.props.userLoginSuccessful();
			}
		});
	};

	render() {
		const accessToken = window.localStorage.getItem("$LoopBack$accessTokenId");
		const userId = localStorage.getItem("$LoopBack$currentUserId");
		const authServiceUrl = apiUrlConfig.apiConfig.authServiceUrl;
		const exchangeTokenUrl = apiUrlConfig.apiConfig.exchangeTokenUrl;
		if (accessToken) {
			this.authenticateUser(accessToken).then(res => {
				if (res.alive) {
					window.localStorage.setItem("$LoopBack$currentUserId", userId);
					setUserProperties();
				} else {
					window.localStorage.removeItem("$LoopBack$accessTokenId");
					this.loginUser(authServiceUrl, exchangeTokenUrl);
				}
			});
		} else {
			this.loginUser(authServiceUrl, exchangeTokenUrl);
		}

		return <p>Redirecting...</p>;
	}
}

export default Login;
